import {
  ErrorComponent
} from "./chunk-IZ5P4IMI.mjs";
import {
  HintComponent
} from "./chunk-L7AGPMCB.mjs";

// src/label/src/hint-and-error-message.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var HintAndErrorMessage = ({
  hasHint,
  hintId,
  hint,
  errorId,
  hasError,
  errorMessage,
  disabled = false
}) => {
  if (!hasHint && !hasError)
    return null;
  return /* @__PURE__ */ jsxs("span", { className: "grid gap-2", children: [
    hasHint ? /* @__PURE__ */ jsx(HintComponent, { disabled, hint, hintId }) : null,
    hasError ? /* @__PURE__ */ jsx(
      ErrorComponent,
      {
        disabled,
        errorId,
        errorMessage
      }
    ) : null
  ] });
};

export {
  HintAndErrorMessage
};
